function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Constants } from '@shared/utils/constants';
import { launchTelemetry } from '@shared/utils/reviewsUtils';
import { AppReviewItemCommentComposer } from '@shared/components/appReviewItemCommentComposer';
import { logger } from '@src/logger';
import { AppReviewItemCommentCollectionListSection } from '@shared/components/appReviewCommentCollection/appReviewItemCommentCollectionListSection';
export const AppReviewCommentCollection = ({ comments = null, expanded, review, loadData, clearData, locale, signedIn, openModal, createComment, deleteComment, editComment, ensureStateInitialized, unloadPages, isStateInitialized = false })=>{
    const [currentPage, setCurrentPage] = useState(1);
    const [composeText, setComposeText] = useState('');
    /**
   * Triggers loading of comments for the current page, if necessary,
   * e.g. during an initial expansion of the component, page navigation.
   */ const loadCurrentPageDataIfNeeded = ()=>{
        if (expanded && loadData && comments) {
            // Load the current page if there are no comments, if the initial loading was never triggered,
            // or if the user navigated to the next page which hasn't yet bee loaded.
            if (!comments.commentIds.length || currentPage > comments.currentLoadedPage) {
                loadData({
                    offerId: review.offer_id,
                    reviewId: review.id,
                    page: currentPage,
                    itemsPerPage: Constants.Reviews.CommentsPerPage
                });
            }
        }
    };
    const loadNextPage = ()=>{
        // If we already loaded enough data, simply append the visible page - otherwise, append both
        setCurrentPage((prev)=>prev + 1);
    };
    const resetPagination = ()=>{
        unloadPages({
            offerId: review.offer_id,
            reviewId: review.id
        });
        setCurrentPage(1);
    };
    const onSeeLessClick = ()=>{
        resetPagination();
        launchTelemetry(Constants.Telemetry.Action.Click, Constants.Telemetry.ActionModifier.ReviewItemCommentsSeeLess, {
            reviewId: review === null || review === void 0 ? void 0 : review.id,
            offerId: review === null || review === void 0 ? void 0 : review.offer_id
        });
        logger.info(JSON.stringify({
            reviewId: review === null || review === void 0 ? void 0 : review.id,
            offerId: review === null || review === void 0 ? void 0 : review.offer_id
        }), {
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.ReviewItemCommentsSeeLess
        });
    };
    const onSeeMoreClick = ()=>{
        loadNextPage();
        launchTelemetry(Constants.Telemetry.Action.Click, Constants.Telemetry.ActionModifier.ReviewItemCommentsSeeMore, {
            reviewId: review === null || review === void 0 ? void 0 : review.id,
            offerId: review === null || review === void 0 ? void 0 : review.offer_id
        });
        logger.info(JSON.stringify({
            reviewId: review === null || review === void 0 ? void 0 : review.id,
            offerId: review === null || review === void 0 ? void 0 : review.offer_id
        }), {
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.ReviewItemCommentsSeeMore
        });
    };
    const openSignInModal = ()=>{
        openModal({
            modalId: Constants.ModalType.SignIn
        });
        launchTelemetry(Constants.Telemetry.Action.Click, Constants.Telemetry.ActionModifier.ReviewItemCommentsSignIn, {
            reviewId: review === null || review === void 0 ? void 0 : review.id,
            offerId: review === null || review === void 0 ? void 0 : review.offer_id
        });
        logger.info(JSON.stringify({
            reviewId: review === null || review === void 0 ? void 0 : review.id,
            offerId: review === null || review === void 0 ? void 0 : review.offer_id
        }), {
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.ReviewItemCommentsSignIn
        });
    };
    const shouldNewCommentEnterNewlyAddedList = ()=>{
        return currentPage < comments.totalPages;
    };
    const onSubmitComment = (content)=>_async_to_generator(function*() {
            if (createComment) {
                try {
                    const res = yield createComment({
                        offerId: review.offer_id,
                        reviewId: review.id,
                        addToNewlyAdded: shouldNewCommentEnterNewlyAddedList(),
                        content
                    });
                    if (!(res === null || res === void 0 ? void 0 : res.error)) {
                        setComposeText('');
                        launchTelemetry(Constants.Telemetry.Action.Submitted, Constants.Telemetry.ActionModifier.ReviewItemCommentCreationSubmit, {
                            reviewId: review === null || review === void 0 ? void 0 : review.id,
                            offerId: review === null || review === void 0 ? void 0 : review.offer_id,
                            content
                        });
                        logger.info(JSON.stringify({
                            reviewId: review === null || review === void 0 ? void 0 : review.id,
                            offerId: review === null || review === void 0 ? void 0 : review.offer_id,
                            content
                        }), {
                            action: Constants.Telemetry.Action.Submitted,
                            actionModifier: Constants.Telemetry.ActionModifier.ReviewItemCommentCreationSubmit
                        });
                    }
                } catch (e) {
                    launchTelemetry(Constants.Telemetry.Action.SubmitError, Constants.Telemetry.ActionModifier.ReviewItemCommentCreationSubmit, {
                        reviewId: review === null || review === void 0 ? void 0 : review.id,
                        offerId: review === null || review === void 0 ? void 0 : review.offer_id,
                        error: `Encountered an error while attempting to create a comment, error: ${e}`
                    });
                    logger.error(JSON.stringify({
                        reviewId: review === null || review === void 0 ? void 0 : review.id,
                        offerId: review === null || review === void 0 ? void 0 : review.offer_id,
                        error: `Encountered an error while attempting to create a comment, error: ${e}`
                    }), {
                        action: Constants.Telemetry.Action.SubmitError,
                        actionModifier: Constants.Telemetry.ActionModifier.ReviewItemCommentCreationSubmit
                    });
                }
            }
        })();
    const onComposerTextChange = (newContent)=>{
        setComposeText(newContent);
    };
    useEffect(()=>{
        if (expanded) {
            ensureStateInitialized({
                offerId: review.offer_id,
                reviewId: review.id,
                totalComments: review.comments_count
            });
        }
        loadCurrentPageDataIfNeeded();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expanded,
        currentPage,
        isStateInitialized
    ]);
    useEffect(()=>{
        if (isStateInitialized && comments.currentLoadedPage) {
            clearData({
                offerId: review.offer_id,
                reviewId: review.id
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        signedIn
    ]);
    useEffect(()=>{
        return ()=>{
            clearData({
                offerId: review.offer_id,
                reviewId: review.id
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return expanded && comments !== null && /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(AppReviewItemCommentCollectionListSection, {
                comments: comments,
                currentPage: currentPage,
                locale: locale,
                totalPageCount: comments.totalPages,
                onSeeMoreClick: ()=>onSeeMoreClick(),
                onSeeLessClick: ()=>onSeeLessClick(),
                onCommentDelete: (commentId, isNewlyAddedComment)=>{
                    deleteComment({
                        commentId,
                        offerId: review.offer_id,
                        reviewId: review.id,
                        isNewlyAddedComment
                    });
                },
                onCommentEdit: (commentId, updatedContent, isNewlyAddedComment)=>{
                    editComment({
                        offerId: review.offer_id,
                        reviewId: review.id,
                        commentId,
                        isNewlyAddedComment,
                        updatedContent
                    });
                }
            }),
            /*#__PURE__*/ _jsx(AppReviewItemCommentComposer, {
                onChange: (content)=>onComposerTextChange(content),
                signedIn: signedIn,
                openSignInModal: ()=>openSignInModal(),
                onSubmit: ()=>{
                    onSubmitComment(composeText);
                },
                initialContent: composeText
            })
        ]
    });
};
